import { render } from "./SiblingDiscountManagement.vue?vue&type=template&id=5e900419&scoped=true"
import script from "./SiblingDiscountManagement.vue?vue&type=script&lang=js"
export * from "./SiblingDiscountManagement.vue?vue&type=script&lang=js"

import "./SiblingDiscountManagement.vue?vue&type=style&index=0&id=5e900419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e900419"]])

export default __exports__